import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmacaoService, MensagemService, ProgressoService, Restricao, RestricaoOperador, Restricoes } from 'maestro-ng';
import { DataSourceRouted } from '../../util/data-source-routed';
import { FonteDados, TipoFonteDados } from '../fonte-dados.model';
import { FonteDadosService } from '../fonte-dados.service';

@Component({
  selector: 'app-fonte-dados-lista',
  templateUrl: './fonte-dados-lista.component.html',
  styleUrls: ['./fonte-dados-lista.component.css'],
})
export class FonteDadosListaComponent implements OnInit {
  ds: DataSourceRouted<FonteDados, number>;

  constructor(
    private service: FonteDadosService,
    private confirmacaoService: ConfirmacaoService,
    private progressoService: ProgressoService,
    private mensagemService: MensagemService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.ds = new DataSourceRouted<FonteDados, number>(
      'fonte-dados-lista',
      (c) => this.service.recuperarPaginado(c),
      this.mensagemService,
      this.progressoService,
      this.route,
      this.router,
      15,
      new Restricoes([
        new Restricao<number>({ atributo: 'id', operador: RestricaoOperador.EQUALS }),
        new Restricao<string>({ atributo: 'nome', operador: RestricaoOperador.START_WITH }),
        new Restricao<string>({ atributo: 'url', operador: RestricaoOperador.START_WITH }),
        new Restricao<string>({ atributo: 'tipo', operador: RestricaoOperador.EQUALS, valor: TipoFonteDados.EXTRATOR }),
      ])
    );
  }

  ngOnInit(): void {}

  iniciarExclusao(fonteDados: FonteDados): void {
    this.confirmacaoService.confirmar({
      mensagem: 'Você tem certeza que deseja excluir a fonte de dados?',
      aceitar: () => {
        this.service
          .excluir(fonteDados)
          .then(() => {
            this.ds.atualizar();
          })
          .catch((response) => {
            this.mensagemService.addErro('Erro', response.error);
          });
      },
    });
  }
}
